import {createRoot} from 'react-dom/client'
import './index.css'
import App from "@/App.tsx";
import {StrictMode} from "react";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {Toaster} from "@/components/ui/toast.tsx";
import * as Sentry from "@sentry/react";
import {InstallPrompt} from "@/pwa/installPrompt.tsx";
import {TooltipProvider} from "@/components/ui/tooltip.tsx";

Sentry.init({
    dsn: "https://fc2b35ba499259c8b9516cdf86c6e13f@sentry.kivi.bz.it/62",
    environment:
        import.meta.env.DEV
            ? "development"
            : "production",
    tracesSampleRate: 0.01,
});
const queryClient = new QueryClient()

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <TooltipProvider>
                <App/>
                <InstallPrompt/>
                <Toaster/>
            </TooltipProvider>
        </QueryClientProvider>
    </StrictMode>,
)
